import React from 'react';
import AnimatedSection from './AnimatedSection';
import SectionIntro from './SectionIntro';

const steps = [
  { title: 'Research', desc: 'Understand your operations, guests, and growth goals.' },
  { title: 'Design', desc: 'Map workflows into clear, elegant product experiences.' },
  { title: 'Develop', desc: 'Build secure, scalable systems with hospitality-grade reliability.' },
  { title: 'Deploy', desc: 'Launch with training, migration support, and zero-drama cutover.' },
  { title: 'Support', desc: 'Stay close — monitoring, fixes, and continuous partnership.' },
  { title: 'Optimize', desc: 'Iterate with data and AI to improve margins and service.' },
];

const Process: React.FC = () => {
  return (
    <section id="process" className="section-pad bg-surface-secondary/30 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <SectionIntro
          label="Process"
          title="From discovery to continuous optimization."
          body="A disciplined partnership model — not a one-off build and disappear."
          className="mb-14 md:mb-16"
        />

        <div className="relative">
          {/* Timeline line */}
          <div className="hidden md:block absolute top-8 left-0 right-0 h-px bg-surface-border" />
          <div className="hidden md:block absolute top-8 left-0 h-px bg-surface-border w-full" />

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-4">
            {steps.map((step, i) => (
              <AnimatedSection key={step.title} animation="slide-up" delay={i * 80}>
                <div className="relative pt-0 md:pt-0">
                  <div className="hidden md:flex items-center justify-center mb-6 relative z-10">
                    <div className="w-4 h-4 rounded-full bg-surface border-2 border-primary-500" />
                  </div>
                  <div className="md:text-center">
                    <span className="text-xs text-primary-500 font-medium tracking-widest uppercase mb-2 block">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <h3 className="font-display text-lg font-semibold text-white mb-2">{step.title}</h3>
                    <p className="text-sm text-muted leading-relaxed">{step.desc}</p>
                  </div>
                  {i < steps.length - 1 && (
                    <div className="md:hidden flex justify-center py-3 text-primary-500/40" aria-hidden>
                      ↓
                    </div>
                  )}
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
